import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router5';

import createRouter from './router';
import './index.css';
import App from './App';

const router = createRouter();

console.log('ROUTER', router);

router.start(() => {
    const container = document.getElementById('root');
    if (container) {
        const root = createRoot(container);
        root.render(
            <RouterProvider router={router}>
                <App />
            </RouterProvider>,
        );
    }
});
